// extracted by mini-css-extract-plugin
module.exports = {"container":"sportsList__container___gld1E"};